/* tslint:disable */
/* eslint-disable */
/**
 * app
 * app
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateFacilityPhoneRequest
 */
export interface UpdateFacilityPhoneRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateFacilityPhoneRequest
     */
    primary_phone: string;
}

/**
 * Check if a given object implements the UpdateFacilityPhoneRequest interface.
 */
export function instanceOfUpdateFacilityPhoneRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "primary_phone" in value;

    return isInstance;
}

export function UpdateFacilityPhoneRequestFromJSON(json: any): UpdateFacilityPhoneRequest {
    return UpdateFacilityPhoneRequestFromJSONTyped(json, false);
}

export function UpdateFacilityPhoneRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateFacilityPhoneRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'primary_phone': json['primary_phone'],
    };
}

export function UpdateFacilityPhoneRequestToJSON(value?: UpdateFacilityPhoneRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'primary_phone': value.primary_phone,
    };
}

